import { WMButton, WMButtonVariant } from '@walkme/wm-ui';
import React from 'react';
import classes from './RecipientsListEmptyState.module.scss';

const RecipientsListEmptyState = ({
    title,
    description,
    actionText,
    image,
    onClick
}: {
    title?: string;
    description?: string;
    actionText?: string;
    image?: string;
    onClick?: () => void;
}) => {
    return (
        <div className={classes.root} data-testid={'empty-state'}>
            {image && <img className={classes.emptyImg} src={image} />}
            <span className={classes.title}>{title}</span>

            {description && (
                <span className={classes.description}>
                    {description}{' '}
                    {onClick && actionText && (
                        <WMButton className={classes.link} variant={WMButtonVariant.Text} onClick={onClick}>
                            {actionText}
                        </WMButton>
                    )}
                </span>
            )}
        </div>
    );
};

export default RecipientsListEmptyState;
